import React from 'react';

const IconMedium = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z" transform="translate(-2 -2)" />
      <path fill={color} fillRule="nonzero" d="M22 2v20H2V2h20zM9.244 6.513H5.35v.226l1.254 1.51c.124.112.186.275.17.44v5.938c.036.214-.031.433-.182.59l-1.412 1.712v.225h4.002v-.225l-1.41-1.712c-.153-.156-.225-.374-.195-.59V9.491l3.512 7.663h.408l3.017-7.663V15.6c0 .163 0 .195-.107.301l-1.085 1.054v.225h5.27v-.225l-1.048-1.029c-.093-.07-.139-.186-.12-.3V8.067c-.019-.115.027-.23.12-.301l1.072-1.028v-.226h-3.713l-2.647 6.603-3.01-6.603z" transform="translate(-2 -2)" />
    </g>
  </svg>
);

export default IconMedium;
